<template>
    <div class="fixed-aside">
        <div v-show="showBackTop" class="back-top" @click="scrollToTop"></div>
        <div v-show="isHome" class="aside-item aside-item-toReport pointer" @click="toReport">
            <div class="aside-item-container aside-item-container-toReport">
                <div class="aside-item-wrapper">
                    <div class="toReport-entrance">
                        <img src="../assets/img/toReport.png" alt="">
                    </div>
                    <div class="toReport-entrance-in">
                        <img src="../assets/img/toReport_in.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div v-show="isHome" class="aside-item pointer" @click="toBaoliao">
            <div class="aside-item-container">
                <div class="aside-item-wrapper">
                    <div class="line-submit"></div>
                    <div class="line-submit-in"></div>
                </div>
            </div>
        </div>
        <!-- <div v-show="isHome" class="aside-item pointer" @click="toWeibo">
            <div class="aside-item-container">
                <div class="aside-item-wrapper">
                    <div class="weibo"></div>
                    <div class="weibo-in"></div>
                </div>
            </div>
        </div>
        <div v-show="isHome" class="aside-item pointer with-download-code">
            <div class="aside-item-container">
                <div class="aside-item-wrapper">
                    <div class="weixin"></div>
                    <div class="weixin-in"></div>
                </div>
            </div>
            <div class="code-img weixin-code"></div>
        </div> -->
        <div v-show="isHome" class="aside-item pointer with-download-code">
            <div class="aside-item-container">
                <div class="aside-item-wrapper">
                    <div class="matrix"></div>
                    <div class="matrix-in"></div>
                </div>
            </div>
            <div class="code-box">
                <div class="code-show-box">
                    <div class="show-title">四川举报辟谣矩阵5大账号</div>
                    <div class="show-content">
                        <div class="show-app show-weibo-click active" @mouseenter="changeAppIcon(1)"></div>
                        <div class="show-app show-weixin" @mouseenter="changeAppIcon(2)"></div>
                        <div class="show-app show-douyin" @mouseenter="changeAppIcon(3)"></div>
                        <div class="show-app show-kuaishou" @mouseenter="changeAppIcon(4)"></div>
                        <div class="show-app show-hudie" @mouseenter="changeAppIcon(5)"></div>
                    </div>
                    <div class="show-footer">
                        <div class="show-app-code" style="display: block;" @click="toWeibo">
                            微博主页，点击直达>
                        </div>
                        <div class="show-app-code" style="display: none;">
                            <div class="show-QR"></div>
                            <div>微信公众号</div>
                            <div>扫码访问</div>
                        </div>
                        <div class="show-app-code" style="display: none;">
                            <div class="show-QR"></div>
                            <div>打开抖音</div>
                            <div>扫码访问</div>
                        </div>
                        <div class="show-app-code" style="display: none;">
                            <div class="show-QR"></div>
                            <div>快手主页</div>
                            <div>扫码访问</div>
                        </div>
                        <div class="show-app-code" style="display: none;">
                            <div class="show-QR"></div>
                            <div>微信视频号</div>
                            <div>扫码访问</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-show="isHome" class="weibo with-download-code" @click="toWeibo">
            <div></div>
        </div>
        <div v-show="isHome" class="weixin with-download-code pointer">
            <div></div>
        </div> -->
    </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
    name: "BackTop",
    data() {
        return {
            showBackTop: false,
            isHome: false,
            perClickIndex: 1
        }
    },
    watch: {
        $route (val) {
            if(val.path == '/') {
                this.isHome = true
            }
            else {
                this.isHome = false
            }
        },
    },
    mounted() {
        window.addEventListener('scroll', this.watchScroll)
    },
    destroyed() {
        window.removeEventListener('scroll', this.watchScroll)
    },
    methods: {
        ...mapMutations(['setShowPop']),
        watchScroll() {
            if(Math.ceil((document.body.scrollTop || document.documentElement.scrollTop)) >= (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)) {
                this.showBackTop = true
            } else {
                this.showBackTop = false
            }
        },
        scrollToTop() {
            if(document.body.scrollTop) {
                document.body.scrollTop = 0
            } else if(document.documentElement.scrollTop) {
                document.documentElement.scrollTop = 0
            }
        },
        toWeibo() {
            window.open('https://weibo.com/scpiyao');
        },
        toBaoliao() {
            // var r = window.confirm('您即将进入辟谣联盟成员“封面新闻”官网提交辟谣线索，我们将尽快处理。')
            // if(r) {
            //     window.open('http://www.thecover.cn/cloudHelp')
            // }
            // let flag = localStorage.getItem('notShowPiyaoPop') || false;
            // if(flag) {
                window.open('https://www.scjb.gov.cn/reportInstructions/8');
            //     return;
            // }
            // this.setShowPop(true);
        },
        toReport() {
            window.open('https://www.scjb.gov.cn/reportInstructions/3');
        },
        changeAppIcon(index) {
            const ACTIVE_APP = {
                1: 'weibo',
                2: 'weixin',
                3: 'douyin',
                4: 'kuaishou',
                5: 'hudie'
            }
            document.querySelector('.show-content .active').className = `show-app show-${ACTIVE_APP[this.perClickIndex]}`;
            const activeApp = document.querySelectorAll('.show-content .show-app')[index - 1];
            activeApp.className = `show-app show-${ACTIVE_APP[index]}-click active`;
            this.perClickIndex = index;
            const showAppCode = document.querySelectorAll('.show-footer .show-app-code');
            for(let i = 0; i < showAppCode.length; i++) {
                showAppCode[i].style.display = 'none';
            }
            showAppCode[index - 1].style.display = 'block';
        }
    },
}
</script>
<style lang="less" scoped>
.fixed-aside {
    width: 5.125rem;
    position: fixed;
    bottom: 12rem;
    left: 50%;
    margin-left: 32.0625rem;
    z-index: 999;
    div {
        height: 5.125rem;
        margin-bottom: 0.625rem;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        position: relative;
        // z-index: 1900;
        // border: 1px solid #AED9FF;
        // &:hover {
        //     border: 1px solid #006DF1;
        // }
    }
    .back-top {
        background-image: url('./../assets/img/new_backTop.png');
    }
    // .weibo {
    //     background-image: url('./../assets/img/weibo.png');
    // }
    // .weixin {
    //     background-image: url('./../assets/img/weixin.png');
    // }
    .aside-item {
        margin-bottom: 0.625rem;
        .aside-item-container {
            width: 5.125rem;
            height: 5.125rem;
            overflow: hidden;
            .aside-item-wrapper {
                transition: all .2s;
                white-space: nowrap;
                div {
                    display: inline-block;
                    width: 5.125rem;
                }
                .toReport-entrance {
                    background-image: url('./../assets/img/toReport_bg.png');
                    background-size: 100% 100%;
                    height: 100%;
                    text-align: center;
                    img {
                        width: 2.0625rem;
                        height: auto;
                        margin-top: .875rem;
                    }
                }
                .toReport-entrance-in {
                    background-image: url('./../assets/img/toReport_in_bg.png');
                    background-size: 100% 100%;
                    height: 100%;
                    text-align: center;
                    img {
                        width: 2.0625rem;
                        height: auto;
                        margin-top: .875rem;
                    }
                }
                .line-submit {
                    background-image: url('./../assets/img/lineSubmit.png');
                }
                .line-submit-in {
                    background-image: url('./../assets/img/lineSubmit_in.png');
                }
                .weibo {
                    background-image: url('./../assets/img/new_weibo.png');
                }
                .weibo-in {
                    background-image: url('./../assets/img/new_weibo_in.png');
                }
                .weixin {
                    background-image: url('./../assets/img/new_weixin.png');
                }
                .weixin-in {
                    background-image: url('./../assets/img/new_weixin_in.png');
                }
                .matrix {
                    background-image: url('./../assets/img/matrix.png');
                }
                .matrix-in {
                    background-image: url('./../assets/img/matrix_in.png');
                }
            }
        }
        &:hover {
            .aside-item-container {
                .aside-item-wrapper {
                    transform: translateX(-5.125rem);
                }
            }
        }
    }
    .aside-item-toReport {
        height: 6.125rem;
        .aside-item-container-toReport {
            height: 100%;
            .aside-item-wrapper {
                height: 100%;
            }
        }
    }
    .with-download-code {
        position: relative;
    }
    .with-download-code .code-box {
        position: absolute;
        left: 0rem;
        top: -1px;
        width: 0rem;
        height: 0rem;
        overflow: hidden;
        -webkit-transition: all .3s linear;
        transition: all .3s linear;
        margin-bottom: 0;
        box-sizing: border-box;

        .code-show-box {
            width: 14.4444rem;
            height: 100%;
            background: #F7FBFE;
            border-radius: 2px;
            border: 2px solid #AED9FF;
            margin-bottom: 0;
            box-sizing: border-box;
            .show-title {
                width: 100%;
                height: .6667rem;
                margin-top: .6667rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: .6667rem;
                color: #666666;
                line-height: .6667rem;
                text-align: center;
                font-style: normal;
            }
            .show-content {
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                width: 100%;
                height: 3.2222rem;
                margin-bottom: 0;
                .show-app {
                    width: 2.4444rem;
                    height: 2.4444rem;
                }
                .show-weibo  {
                    background: url(../assets/img/weibo.png) no-repeat;
                    background-size: contain;
                }
                .show-weibo-click  {
                    background: url(../assets/img/weibo_click.png) no-repeat;
                    background-size: contain;
                }
                .show-weixin  {
                    background: url(../assets/img/weixin.png) no-repeat;
                    background-size: contain;
                }
                .show-weixin-click  {
                    background: url(../assets/img/weixin_click.png) no-repeat;
                    background-size: contain;
                }
                .show-douyin  {
                    background: url(../assets/img/douyin.png) no-repeat;
                    background-size: contain;
                }
                .show-douyin-click  {
                    background: url(../assets/img/douyin_click.png) no-repeat;
                    background-size: contain;
                }
                .show-kuaishou  {
                    background: url(../assets/img/kuaishou.png) no-repeat;
                    background-size: contain;
                }
                .show-kuaishou-click  {
                    background: url(../assets/img/kuaishou_click.png) no-repeat;
                    background-size: contain;
                }
                .show-hudie  {
                    background: url(../assets/img/hudie.png) no-repeat;
                    background-size: contain;
                }
                .show-hudie-click  {
                    background: url(../assets/img/hudie_click.png) no-repeat;
                    background-size: contain;
                }
                
            }
            .show-footer {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 0;
                .show-app-code {
                    cursor: pointer;
                    font-size: .6667rem;
                    color: #333;
                    text-align: center;
                    &:nth-child(1) {
                        width: 9.5556rem;
                        height: 2.0556rem;
                        background: #FFFFFF;
                        border-radius: 2px;
                        border: 1px solid #006DF1;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: .7778rem;
                        color: #006DF1;
                        line-height: 2.0556rem;
                        text-align: center;
                        font-style: normal;
                    }
                    &:nth-child(2) .show-QR {
                        width: 5.5556rem;
                        height: 5.5556rem;
                        background: url(../assets/img/weixinQR.jpg) no-repeat;
                        background-size: contain;
                    }
                    &:nth-child(3) .show-QR {
                        width: 5.5556rem;
                        height: 5.5556rem;
                        background: url(../assets/img/douyin.jpg) no-repeat;
                        background-size: contain;
                    }
                    &:nth-child(4) .show-QR {
                        width: 5.5556rem;
                        height: 5.5556rem;
                        background: url(../assets/img/kuaishou.jpg) no-repeat;
                        background-size: contain;
                    }
                    &:nth-child(5) .show-QR {
                        width: 5.5556rem;
                        height: 5.5556rem;
                        background: url(../assets/img/shipinhao.png) no-repeat;
                        background-size: contain;
                    }
                    div {
                        height: .8333rem;
                        margin: 0;
                        line-height: 1.1;
                        margin-bottom: .2222rem;
                    }
                }
            }
        }
    }
    .with-download-code:hover .code-box {
        left: -15rem;
        width: 15rem;
        height: 13.2222rem;
    }
    .with-download-code .code-img {
        position: absolute;
        left: -15rem;
        top: -1px;
        width: 10.875rem;
        height: 10.875rem;
        background-position: center;
        background-size: 9.375rem 9.375rem;
        background-repeat: no-repeat;
        -webkit-transition: none;
        transition: none;
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
        -webkit-transform-origin: right top;
        -ms-transform-origin: right top;
        transform-origin: right top;
        -webkit-transition: all .3s cubic-bezier(.31,.57,.68,1.36);
        transition: all .3s cubic-bezier(.31,.57,.68,1.36)
    }
    .with-download-code:hover .code-img {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }
    .weixin-code {
        background-image: url('./../assets/img/weixinQR.jpg');
    }
}
</style>